import { useEffect, useRef } from 'react';

import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext';

import {
  channelsMetadata,
  IChannelURLData,
  MetaData,
  setChannelMetaData,
} from '@pharmaplan/common';

import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';

const useExistingMetadata = (url: string) => {
  const dispatch = useAppDispatch();

  const store = useSendbirdStateContext();
  const sdk = store?.stores?.sdkStore?.sdk;

  const channelData = useAppSelector(channelsMetadata);
  const channelRef = useRef({});

  channelRef.current = channelData;

  const onMetaData = (res: MetaData) => {
    dispatch(
      setChannelMetaData({ ...channelRef.current, [url]: res as IChannelURLData }),
    );
  };

  useEffect(() => {
    const handleMeta = async () => {
      const channelInstance = await sdk?.groupChannel?.getChannelWithoutCache(
        url,
      );
      channelInstance.getAllMetaData().then(onMetaData);
    };
    handleMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdk]);
};

export default useExistingMetadata;
